import { Tool } from '../../types';

export const serviceManagementTools: Tool[] = [
  {
    id: 'servicem8',
    name: 'ServiceM8',
    category: 'Service Management',
    description: 'Field service management software for small businesses',
    pricing: ['medium'],
    features: ['scheduling', 'job-tracking', 'mobile', 'invoicing', 'field-service'],
    bestFor: ['small-business', 'trades'],
    compatibleWith: ['service-business', 'trades'],
    goals: ['streamline-operations', 'manage-scheduling', 'track-jobs'],
    industries: ['trades', 'home-services'],
    website: 'https://www.servicem8.com',
    imageUrl: 'https://logo.clearbit.com/servicem8.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'housecall-pro',
    name: 'Housecall Pro',
    category: 'Service Management',
    description: 'All-in-one software for home service professionals',
    pricing: ['medium', 'high'],
    features: ['scheduling', 'invoicing', 'mobile', 'job-tracking', 'field-service'],
    bestFor: ['small-business', 'trades'],
    compatibleWith: ['service-business', 'trades'],
    goals: ['streamline-operations', 'manage-scheduling', 'track-jobs'],
    industries: ['trades', 'home-services'],
    website: 'https://www.housecallpro.com',
    imageUrl: 'https://logo.clearbit.com/housecallpro.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];